<script>
import { Bar } from 'vue-chartjs'
const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    xAxes: [{
      stacked: true,
      categoryPercentage: 0.5,
      barPercentage: 1
    }],
    yAxes: [{
      stacked: true
    }]
  }
}
export default {
  extends: Bar,
  props:['chartData'],
  methods: {
    update() {
      this.$data._chart.destroy()
      this.renderChart(this.chartData, options)
    }
  },
  watch: {
    chartData() {
      this.update()
    }
  },
  mounted () {
    this.renderChart(this.chartData, options)
  }
};
</script>
